module.exports = __webpack_public_path__ + "img/share-ui.5afe3a13.png";